import { inject, Injectable } from '@angular/core'
import { FeathersService } from './feathers.service'
import { DateRange } from './date-utils.service'
import { ExchangeEnrollment } from '../models/exchangeEnrollment'

@Injectable({
  providedIn: 'root',
})
export class ExchangeService {
  private feathers = inject(FeathersService)

  private TAG = 'ExchangeService'

  public getActiveEnrollmentsEmbracingRange(range: DateRange) {
    return this.feathers.find(ExchangeEnrollment, {
      queryType: 'activeEnrollmentsEmbracingRange',
      queryProps: {
        range,
      },
    })
  }

  public async deleteEnrollmentById(id: number) {
    await this.feathers.removeById(ExchangeEnrollment.serviceName, id)
  }
}
